import { render, staticRenderFns } from "./bottombar.vue?vue&type=template&id=0f9c7756&scoped=true&"
import script from "./bottombar.vue?vue&type=script&lang=js&"
export * from "./bottombar.vue?vue&type=script&lang=js&"
import style0 from "./bottombar.vue?vue&type=style&index=0&id=0f9c7756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c7756",
  null
  
)

component.options.__file = "bottombar.vue"
export default component.exports